import { createStore } from 'vuex'
import { getDeafutTemplate, getCreateV2Template } from '@/templates/resumeTemplate'
import { message } from "ant-design-vue"
import { updateUserStoreTemplateFn, formatStyleTemplates, updateResumeV2Fn, deleteResumeV2Fn, getResumeV2ListFn, createResumeV2Fn, saveResumePDF2ServerFn } from "../utils/common.js"
import { useStore } from 'vuex'
import { dymicItemWaringFn } from '@/utils/judFengyeLine'

const updateLocalTargetResume = (state, resumeV2UpdateResult, type = 'updateResume') => {
  try {
    if (type === 'updateResume') {
      try {
        let updatedResData = resumeV2UpdateResult?.data?.updateData?.resumeData || '';
        let updatedResId = resumeV2UpdateResult?.data?.updateId || '';
        if (updatedResId && updatedResData) {
          // 通过id更新对应的简历数据
          let targetIndex = state.serverResumeV2List.findIndex(item => item.resumeId === updatedResId);
          // 更新store对应的数据
          if (targetIndex > -1) {
            state.serverResumeV2List[targetIndex].resumeData = updatedResData;
            if (state.curEditServeResumeId === updatedResId) {
              state.selectedResumeTemplate = window.userServerSaveTemplateData = state.templateAddCurstyleTypeData = JSON.parse(updatedResData);
            }
          }
        }
        console.log('本地更新简历数据成功....');
      } catch (error) {
        console.error('本地更新简历数据失败:', error);
      }
    } else if (type === 'updateTitle') {
      try {
        let updateTitleData = resumeV2UpdateResult?.data?.updateData?.resumeTitle || '';
        let updatedResId = resumeV2UpdateResult?.data?.updateId || '';
        if (updatedResId && updateTitleData) {
          // 通过id更新对应的简历数据
          let targetIndex = state.serverResumeV2List.findIndex(item => item.resumeId === updatedResId);
          // 更新store对应的数据
          if (targetIndex > -1) {
            // 更新顶层resumeTitle以触发UI更新
            state.serverResumeV2List[targetIndex].resumeTitle = updateTitleData;

          }
        }
        console.log('本地更新简历标题成功....');
      } catch (error) {
        console.error('本地更新简历标题失败:', error);
      }
    }
  } catch (error) {
    console.log('updateLocalTargetResume error', error);
  }
}

const storeInstance = createStore({
  state: {
    mode: 'markdown',
    theme: '#35394f',
    tabActiveKey: '1',
    resumeTemplateDrawVisible: false,
    selectedResumeTemplate: getDeafutTemplate(),
    fullFinalInfoVisible: false,
    loading: false,
    isLogin: false,
    storeTemplate: '',
    isGangWeiTemplate: false,
    isAiCreateTemplate: false,
    beforePreViewTemplate: null,
    ql_editor_lineHeight: 21.3,// 模块内容行高
    content_marginTop: 0, // 模块上边距
    previewScale: 1,
    userClosedCamera: false,
    showAiEvaluation: false,
    userEmotionReport: '',// 用户情绪报告
    pdfPreviewUrl: '',
    base64ImgAvatar: '',
    modalVipVisible: false,
    modalVipVisibleMsg: 'AI使用',
    aiautoSpeech: true,
    openCheckMaring: true,
    resumeFontFamily: 'system-ui',
    resumeFontScale: 1, // 字号缩放倍数：大(1.5)、中(1.2)、标准(1)、小(0.9)
    downloadCount: 99,
    curNavItemKey: 'templatePage',
    aiCreateData: {},
    aiCreateDataArr: [],
    resetAIinterviewer: true,
    vipData: {
      status: 0
    },
    resumeData: {
      aiuseNum: 3
    },
    userInfos: {
      userid: '',
      username: ''
    },
    storeTimer: null,
    editeResumeObj: {
      resumeId: '',
      mdStr: '',
      htmlStr: '',
      title: '',
    },
    resumeListArr: [],
    targetEmail: '',
    templateDataObj: null,// 用户保存在后端的简历数据
    curstyleTypeObj: null,// 用户保存在后端的简历数据对应的风格模板
    templateAddCurstyleTypeData: null,// templateDataObj与curstyleTypeObj合并后的数据
    templateArr: [],  
    serverResumeV2List: [],// 服务器存储的简历列表
    curEditServeResumeId: '',// 当前编辑的服务器存储的简历id
    defaultServeResumeData: {},// 默认服务器存储的简历
    showGongluePage: true,// 是否显示求职攻略页面
  },
  mutations: {
   async CHANGE_CHECKMWAING (state) {
      state.openCheckMaring = !state.openCheckMaring;
      try {
        console.log('watch CHANGE_CHECKMWAING=====>');
        let waringResult = await dymicItemWaringFn();
        console.log('waringResult:', waringResult)
      } catch (error) {
        console.log('err=>', error);
      }
    },
    CHANGE_SLIDERVALUE (state, value) {
      state.previewScale = value;
      window.previewScale = value;
    },
    async UPDATE_RESUME (state, updateParams = {
      resumeId: '',
      resumeTitle: '',
      resumeDesc: '',
      resumeData: '',
    }) {
      try {
        let resumeV2UpdateRes = await updateResumeV2Fn({
          state
        }, updateParams);
        if (resumeV2UpdateRes.code === 0) {
          updateLocalTargetResume(state, resumeV2UpdateRes, 'updateTitle');
          message.success('简历更新保存成功');
          window?.$Bus?.emit('closeEditTitle');
        } else {
          message.error('简历更新保存失败');
        }
      } catch (error) {
        console.log('UPDATE_RESUME error:', error);
        message.error('简历更新保存失败');
      }
    },
    async GET_RESUME_LIST (state, value) {
      try {
        let resumeV2ListRes = await getResumeV2ListFn({
          state
        });
        state.serverResumeV2List = resumeV2ListRes?.data?.listRes || [];
      } catch (error) {
        console.log('GET_RESUME_LIST error:', error);
        message.error('获取我的简历列表失败');
      }
    },
    async DELETE_RESUME_ITEM (state, delteId) {
      try {
        let resumeV2DelRes = await deleteResumeV2Fn({
          state
        }, delteId);
        if (resumeV2DelRes.code === 0) {
          state.serverResumeV2List = state.serverResumeV2List.filter(item => item.resumeId !== delteId);
          message.success('简历删除成功');
        } else {
          message.error(resumeV2DelRes.msg || '简历删除失败');
        }
      } catch (error) {
        console.log('DELETE_RESUME_ITEM error:', error);
        message.error('简历删除失败');
      }
    },
    async CREATE_RESUME_NEW (state) {
      try {
        state.loading = true;
        let resumeData = getCreateV2Template();
        let createrResumeV2Res = await createResumeV2Fn({
          state
        }, JSON.stringify(resumeData));
        state.loading = false;
        if (createrResumeV2Res.code === 0) {
          let newResumeData = createrResumeV2Res?.data?.createRes || '';
          state.serverResumeV2List.unshift(newResumeData);
          state.curEditServeResumeId = newResumeData.resumeId;
          try {
            state.selectedResumeTemplate = JSON.parse(newResumeData.resumeData);
          } catch (error) {
            console.error('解析新建简历数据失败:', error);
            state.selectedResumeTemplate = getCreateV2Template();
          }
          message.success('创建简历成功');
        } else {
          message.error(createrResumeV2Res.msg || '创建简历失败');
        }
        console.log('createrResumeV2Res:', createrResumeV2Res);
      } catch (error) {
        console.log('CREATE_RESUME_NEW error:', error);
        message.error('创建简历失败');
      }
    },
    async SAVE_RESUME_PDF (state, payload) {
      const { callback, ...params } = payload;
      try {
        // params 包含 file 和 targetEmail
        state.targetEmail = params.targetEmail;
        let saveResumePDF2ServerRes = await saveResumePDF2ServerFn({state}, params);
        console.log('saveResumePDF2ServerRes:', saveResumePDF2ServerRes);
        callback && callback(saveResumePDF2ServerRes);
        return saveResumePDF2ServerRes;
      } catch (error) {
        console.log('SAVE_RESUME_PDF error:', error);
        callback && callback(null, error);
      }
    },
    CHANGE_LINEHEIGHT (state, value) {
      state.ql_editor_lineHeight = value;
    },
    CHANGE_CONTENTMARGINTOP (state, value) {
      state.content_marginTop = value;
    },
    RESET_CHANGE_LINEHEIGHT_CONTENTMARGINTOP (state) {
      state.ql_editor_lineHeight = 21.3;
      state.content_marginTop = 0;
    },
    CHANGE_BEFOREPREVIEWTEMPLATE (state, value) {
      state.beforePreViewTemplate = value;
      window.beforePreViewTemplate = value;
      console.log('CHANGE_BEFOREPREVIEWTEMPLATE....');
    },
    CHANGE_AICREATEDATA (state, value) {
      state.aiCreateData = value;
      window.aiCreateData = value;
      console.log('CHANGE_AICREATEDATA....');
    },
    CHANGE_AICREATEDATAARR (state, value) {
      state.aiCreateDataArr = value;
      window.aiCreateDataArr = value;
      console.log('CHANGE_AICREATEDATAARR....');
    },
    CHANGE_MODE (state, mode) {
      state.mode = mode
    },
    CHANGE_RESUMEFONTFAMILY (state, type) {
      state.resumeFontFamily = type
    },
    CHANGE_RESUMEFONTSCALE (state, value) {
      state.resumeFontScale = value
    },
    CHANGE_TEMPLATE_STATUS (state) {
      state.resumeTemplateDrawVisible = !state.resumeTemplateDrawVisible
    },
    CHANGE_RESUME_TEMPLATE (state, template) {
      state.selectedResumeTemplate = template
      state.base64ImgAvatar = '';
      // console.log('CHANGE_RESUME_TEMPLATE====>', template);
    },
    CHANGE_RESUME_THEME (state, color) {
      state.theme = color
    },
    CHANGE_FULL_INFO (state) {
      state.fullFinalInfoVisible = !state.fullFinalInfoVisible
    },
    STORE_TEMPLATE_DATA (state, type = 'update') {
      let storeTemplate = {}
      for (const key in state.selectedResumeTemplate) {
        if (Object.hasOwnProperty.call(state.selectedResumeTemplate, key)) {
          const item = state.selectedResumeTemplate[key];
          if (key != 'newcover') {
            storeTemplate[key] = item;
          }
        }
      };
      state.storeTemplate = storeTemplate;
      localStorage.setItem('userSaveResume', JSON.stringify(storeTemplate));
      console.log('STORE_TEMPLATE_DATA', storeTemplate);
      const store = {
        state
      }
      // 不是默认简历
      if (state.curEditServeResumeId !== '12345678') {
        console.log('保存-不是默认简历');
        updateResumeV2Fn({
          state
        }, {
          resumeId: state.curEditServeResumeId,
          resumeData: JSON.stringify(storeTemplate),
          resumeTitle: '',
          resumeDesc: '',
        }).then(rsp => {
          if (rsp.code !== 0) {
            message.error(rsp.msg || '保存失败');
          } else {
            updateLocalTargetResume(state, rsp, 'updateResume');
            message.success('更新保存成功');
          }
        }).catch(err => {
          message.error(err.msg || '保存失败');
        })
        return;
      }

      updateUserStoreTemplateFn(JSON.stringify(storeTemplate), store, type).then(rsp => {
        const resMsg = rsp.msg || '保存成功';
        const updateResumeData = rsp.data.updateAfterItem || {};
        // 更新store对应的数据
        store.state.resumeData = updateResumeData;
        store.state.editeResumeObj = updateResumeData.editResumeObj;
        store.state.resumeListArr = updateResumeData.resumeListArr || [];
        store.state.templateDataObj = JSON.parse(updateResumeData.templateStr || '{}');
        // 更新templateArr 风格模版
        let {
          allStyleTempArr,
          useStyleTemp,
          templateData,
          templateAddCurstyleTypeData
        } = formatStyleTemplates(store.state.templateDataObj, store);
        // 更新本地数据
        state.selectedResumeTemplate = templateAddCurstyleTypeData;
        state.defaultServeResumeData.resumeData = templateAddCurstyleTypeData; // 更新默认简历数据
        message.success(resMsg);
      }).catch(err => {
        message.error(err.msg || '保存失败');
      })
    }
  }
})

export default storeInstance;
